import React from 'react';
import NavBox from './NavBox/NavBox';
import * as classes from './Navigation.module.css';

const Navigation = (props) =>{

    let navComponents = [];

    for (let type in props.caramels) {
        navComponents.push(
            <NavBox
                key={type}
                image={props.caramels[type].caramel.image}
                color={props.caramels[type].caramel.color}
                clicked={(e) => {
                    e.stopPropagation();
                    props.clicked(type);
                }}
                active={props.active === type}
            />
        )
    }

    return (
        <div
            className={classes.NavigationContainer}
        >
            {navComponents}
        </div>
    )
};

export default Navigation;